import { render, staticRenderFns } from "./RollOptionSelector.vue?vue&type=template&id=24bfb8cd&"
import script from "./RollOptionSelector.vue?vue&type=script&lang=ts&"
export * from "./RollOptionSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports